<main role="main" class="not-home-page">
  <div class="container">
    <div class="row" [class.mb-5]="!resultsShow.length">
      <div class="col-md-12 index-up">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">

            <li class="breadcrumb-item"><a href="javascript:void(0)" [routerLink]="['/']"
                routerLinkActive="router-link-active">{{"general.Accueil" | translate}}</a></li>
            <li class="breadcrumb-item active">Recherche</li>
          </ol>
        </nav>
        <h2>La Recherche</h2>                
        <form class="form-ap" action="" method="get">
          <div class="form-group d-flex">
            <div class="form-row" style="width: 100%;">
              <div class="col">
                <input [(ngModel)]="searchInput" name="Search" class="form-control" type="text"
                  placeholder="{{'AppelOffre.Saisissezmotcles' | translate}}">
              </div>
            </div>
            <button class="btn btn-info" [class.pr-5]="!isArab" [class.pl-5]="isArab" (click)="searchClicked()">
              {{"AppelOffre.LancerRecherche" | translate}} <span class="icon-search"></span>
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
  <section class="c-appels-offres" *ngIf="resultsShow.length > 0">
    <div class="container">
      <div class="row">
        <div class="col d-flex justify-content-between">
          <h2 class="size18 text-uppercase mb-3">{{"archive.ResultatRecherche" | translate}}: </h2>
          <p class="size18 text-uppercase text-white mt-4 pt-1 mb-3">{{results.length}} {{"archive.PublicationTrouve" |
            translate}}</p>

        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div *ngFor="let item of resultsShow">
            <a *ngIf="item.Type ==='api'" href="javascript:void(0)" [routerLink]="item.ApplicationUrl"
              routerLinkActive="router-link-active">
              <div class="block-archive d-flex align-items-start flex-column">

                <div class="d-flex justify-content-end w-100">
                  <h6> <span class="badge badge-secondary blueBack">{{item.badge}}</span></h6>&nbsp;<h3
                    class="titre-appels size18">{{titleDescription(item.Title,120)}}</h3>
                  <div class="date-appels">{{converteDate(item.DateCreation)}} </div>
                </div>
                <p style="color: black  !important;">{{titleDescription(item.Description,200)}}</p>
              </div>
            </a>
            <span *ngIf="item.Type !=='api'">
              <a *ngIf="item.format.toLowerCase() !== 'html'" [href]="item.url" target="_blank" download>
                <div class="block-archive d-flex align-items-start flex-column">

                  <div class="d-flex justify-content-end w-100">
                    <h6> <span class="badge badge-secondary blueBack">{{item.badge}}</span></h6>&nbsp;<h3
                      class="titre-appels size18">{{titleDescription(item.Titre,120)}}</h3>
                     <div class="date-appels">{{converteDate(item.DateCreation)}} </div> 
                  </div>
                  <!-- <p style="color: black  !important;">{{titleDescription(item.Description,200)}}</p> -->
                </div>
              </a>
              <a href="javascript:void(0)" *ngIf="item.format.toLowerCase() === 'html' && !item.Ports"
                (click)="getPageStatiqueUrl(item.id)">
                <div class="block-archive d-flex align-items-start flex-column">

                  <div class="d-flex justify-content-end w-100">
                    <h6> <span class="badge badge-secondary blueBack">{{item.badge}}</span></h6>&nbsp;<h3
                      class="titre-appels size18">{{titleDescription(item.Titre,120)}}</h3>
                    <!-- <div class="date-appels">{{item.dateShow}} </div> -->
                  </div>
                  <!-- <p style="color: black  !important;">{{titleDescription(item.Description,200)}}</p> -->
                </div>
              </a>
              <a href="javascript:void(0)" *ngIf="item.format.toLowerCase() === 'html' && item.Ports"
                (click)=" getServicePortUrl(item.id, item.listName)">
                <div class="block-archive d-flex align-items-start flex-column">

                  <div class="d-flex justify-content-end w-100">
                    <h6> <span class="badge badge-secondary blueBack">{{item.badge}}</span></h6>&nbsp;<h3
                      class="titre-appels size18">{{titleDescription(item.Titre,120)}}</h3>
                    <!-- <div class="date-appels">{{item.dateShow}} </div> -->
                  </div>
                  <!-- <p style="color: black  !important;">{{titleDescription(item.Description,200)}}</p> -->
                </div>
              </a>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right"><a class="btn btn-info pr-5" href="javascript:void(0)"
            (click)="chargerPlus()">{{"archive.AfficherPlus" | translate}}</a></div>
      </div>
    </div>
  </section>

</main>
<br><br>